var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-cell-list-item clinician-patients-list"},[_c('a',{staticClass:"ag-cell-click",on:{"click":_vm.showDetail}},[_vm._v("\n    "+_vm._s(_vm.episodeId)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }